// extracted by mini-css-extract-plugin
export const navigationButton = "navigation-buttons-module--navigationButton--7KS45";
export const navLabel = "navigation-buttons-module--navLabel--2Shee";